import SpotChecks from "./SpotChecks";
export default SpotChecks;
